<style lang="scss" scoped>
	@import "./main.css";
	.firimg {
		width: 1.3rem;
		// margin-right: 1.6rem;
		// transition: all .5s ease-in-out;
		// -webkit-transition: all .5s ease-in-out;
		// -moz-transition: all .5s ease-in-out;
		// -ms-transition: all .5s ease-in-out;
		// -o-transition: all .5s ease-in-out;
	}
	// .firimg:hover{
	// 	    transform: rotateY(180deg);
	// 	    -webkit-transform: rotateY(180deg);
	// 		-moz-transform: rotateY(180deg);
	// 		-ms-transform: rotateY(180deg);
	// 		-o-transform: rotateY(180deg)
	// }
	.firimg1 {
		width: 2.3rem;
		// margin-right: 1.6rem;
	}
	
</style>
<style lang='scss'>
	#mainView{
		.ant-popover-inner{
			    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.15);
		}
		.hoverfont:hover{
			color: #0C8B96;
		}
		.hoverfont{
			font-weight: 600;font-size: .8rem;color: #000000;
			cursor:pointer;
		}
		.morediv{
			padding-right: 1.6rem;
		}
	}
	
</style>
<template>
	<div id="mainView" style="width:100%;height:100%;">
		<a-layout>
			<a-layout-header :style="{ position: 'fixed', zIndex: 10, width: '100%' }">
				<div class="headerLeft">
					<!-- <img src="../../image/logo2.png" class="logoImg"> -->
					<!-- <span>開戶管理系統</span> -->
					<img src="../../image/khlogo.png" style="width: 14rem;">
					<img src="../../image/mainList.png" class="mainListIcon" @click="sideBol=!sideBol">
					<span style="padding: 0 20px;font-size: 0.8rem;color: #0c8b97;" v-if="$store.state.title == 'cs@qmis.com.hk'">郵箱管理</span>
					<span style="padding: 0 20px;font-size: 0.8rem;color: #0c8b97;" v-else-if="$store.state.title == '230710' || $store.state.title == '201231'"></span>
					<span v-text='$store.state.title' style="padding: 0 20px;font-size: 0.8rem;color: #0c8b97;" v-else></span>
				</div>
				<!-- <div class="headerCenter"> -->
					<!-- <span>開戶管理系統</span> -->
				<!-- </div> -->
				<div class="headerRight">
					<input type="text" class='warp_input'>
						<img :src="require('@/image/heardright/findicon.png')" alt="" class='imgs'>
					</input>
					<!-- <span class="headerRightSpan">{{timeMess}}</span> -->
					<!-- <img :src="item" alt="" v-for='(item,ind) in headright' class='firimg'> -->
					<div v-for='(item,ind) in headright'  class='morediv' :key='ind+"00001"'  @click='handicon(ind)' @mouseenter="isbright = ind" @mouseleave="isbright = ''">
						<a-popover  placement="bottom" :destroyTooltipOnHide="true" trigger="hover"
							 :overlayStyle="{width:item.widths}"
							:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
							<template slot="content">
								<div style="font-size: .7rem;">{{item.name}}</div>
								</template>
								<a href="mailto:enquiry@qmisit.com" v-if='ind==3'>
									<img :src="isbright === ind?item.imgurl1:item.imgurl" alt="" :class='ind==0?"firimg1":"firimg"'>
								</a>
								   <a-badge v-else-if='ind==1' :count="island">
									   <img :src="isbright === ind?item.imgurl1:item.imgurl" alt="" :class='ind==0?"firimg1":"firimg"' @click='handis(item.obj)'>
								    </a-badge>
							
							<img v-else :src="isbright === ind?item.imgurl1:item.imgurl" alt="" :class='ind==0?"firimg1":"firimg"' @click='handurl(ind)'>
						</a-popover>
					</div>
					<!-- <div class="tcDlView" @click="tcEvent()">
						<div class="tcSpan">
							<img src="../../image/heardright/return.png">
							登出
						</div>
					</div> -->
					<!-- <img src="../../image/icon_tuichu.png"> -->
					<a-popover :visible="isshowk" placement="bottomRight" :destroyTooltipOnHide="true" trigger="click"
						@visibleChange="shEvent()" :overlayStyle="{width:'calc(15rem + 22px)'}"
						:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
						<template slot="content">
							<div class="tableBzView">
								<div  style="font-size: .8rem;font-weight: 600;color: #000000;">歡迎，{{form.realname}}</div>
								<div class="tableBzViewList">
									<a-collapse style="background-color:#fcfcfc;" expandIconPosition="right"
										:accordion="true" :bordered="false">
										<div class='hoverfont' @click='handab = true'>查看我的個人資料</div>
										<div style="font-size: .5rem;">QMIS FINANCIAL GROUP</div>
										<div
											style="margin: 0.3rem 0;border-bottom:1px solid #d8d8d8;width: 100%;height: 1px;">
										</div>
										<span style="font-size: .8rem;">最近登入 : </span>
										<span style="font-size: .71rem;">{{form.lastlogintime}}</span>
										<div style="margin-left: 3.9rem;font-size: .71rem;">[QMIS NET]</div>
										<div style="margin: .2rem 0 .3rem;">
										<span style="font-size: .8rem;">本地時間 : </span>
										<span style="font-size: .71rem;">{{timeMess}} GMT+08:00</span>
										</div>
										<div class="tcDlView" style="width: 100%;margin: .5rem 0;" @click="handoutimg=true">
											<div class="tcSpan" style="width: 100%;text-align: center;">
												<!-- <img src="../../image/heardright/return.png"> -->
												登 出
											</div>
										</div>
									</a-collapse>
								</div>
							</div>
						</template>
						<!-- <div class="tcDlView"> -->
							<!-- <div class="tcSpan" style="padding: .3rem .8rem .3rem 1rem;"> -->
								<!-- <img src="../../image/heardright/useis.png" style="width: 1.1rem;"> -->
								<img :src="require('@/image/heardright/meis.png')" alt="" class='firimg'>
							<!-- </div> -->
						<!-- </div> -->
					</a-popover>
					<!-- <a-badge dot style="margin-right:1.2rem;"> -->
					<!-- <img src="../../image/mainMess.png" class="mainListIcon"> -->
					<!-- </a-badge>  -->
				</div>
			</a-layout-header>
			<a-layout-content id="drawerContainer" >
				<a-drawer :mask="true" :visible="sideBol" :maskClosable="true" placement="left" :getContainer="false"
					:wrap-style="{ position: 'fixed',top : '3.5rem' , height: 'calc(100vh - 3.5rem)'}" @close="onClose"
					:closable="false">
					<div class="memberView">
						<div class="memberImgView">
							<div>
								<img :src="headpic" class="txImg">
							</div>
							<div class="textView">
								<p><span class="span1">Hello,</span><span class="span2">{{userName}}</span></p>
								<!-- <p class="onlineView"><i class="onlineCView"></i><span class="span3">online</span></p> -->
							</div>
						</div>
						<div class="memeberSearchView">
							<a-input-search v-model='searchstr' placeholder="搜索" style="width:100%;"/>
							<!-- @search="onSearch" -->
						</div>
					</div>
					<!-- <a-menu :defaultSelectedKeys="[deKeyIndex]" :defaultOpenKeys="[deOpenKeys]" mode="inline"
						@click="menuClick">
						<template v-for="(item) in menuList">
							<a-menu-item v-if="item.secondLevel.length==0 && item.isshow" :key="item.menuid">
								<router-link style="color:inherit;" :to="item.url||''" @click.native="hand12">
									<img class="sideImg" :src="colorKey == item.menuid ? item.openpic : item.closepic">
									<span class="sideTitle">{{item.title}}</span>
								</router-link>
							</a-menu-item>
							<sub-menu v-else-if="item.secondLevel.length>0 && item.isshow"
								v-on:changeSideBol="changeSideBol($event)" :colorKey="colorKey" :key="item.menuid"
								:sideBol="sideBol" :menu-info="item" />
						</template>
					</a-menu> -->
					<div style="height: calc(100vh - 11.5rem);overflow-y: auto;" v-if="false">
						<div v-for='(item,ind) in menuList'>
							<div>
								<div class='gre-title' @click='handfar(item,ind)' >
									<img :src="colorKey == item.menuid ? item.openpic : item.closepic" alt="" style="width: 1rem;margin: -0.1rem .1rem 0 0;position: relative;left:-.5rem">
									<span  :style="{color:item.searchflag==1?'orange':''}">
										{{item.title}}
									</span>
									<a-icon type="right"  class='icon-right'
										:class='item.isshow?"icon-right0":"icon-right1"' />
								</div>
								<div v-if='item.secondLevel'>
									<div :style="{height:item.isshow?'0px':2.3*(item.secondLevel.length+item.thirdLevel1)+'rem'}" class="warp_top aaa">
										<!-- , height:val.isshow?"2.3rem":2.3*(val.thirdLevel.length+1)+"rem" style="transition: height 0.5s ease-out 0s;" -->
										<div v-for="(val,index) in item.secondLevel" class='wil-list'   style="transition: height 0.5s ease-out 0s;"
											:style='{color:val.searchflag==1?"orange":staticadmin == val.menuid?"#0c8b97":"" , height:val.isshow?"2.3rem":2.3*(val.thirdLevel.length+1)+"rem" }'>
											<div @click="hand12(val,index,ind)" style="position: relative;">
												{{val.title}}
												<a-icon type="caret-right" class='icon-right' v-if="val.thirdLevel.length>0" :class='val.isshow?"icon-right0":"icon-right1"' />
											</div>
											<div v-if='val.thirdLevel'>
												<div :style="{height:val.isshow?'0px':2.3*val.thirdLevel.length+'rem'}" class="warp_top ">
													<div v-for="val1 in val.thirdLevel"  class='wil-list' style="padding-left:1rem;" @click="hand13(val1)">
														{{val1.title}}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div style="height: calc(100vh - 11.5rem);overflow-y: auto;" v-if="true">
						<div v-for='(item,ind) in menuList' :key="ind">
							<div class='gre-title' @click='handfar(item,ind)'>
								<img :src="colorKey == item.menuid ? item.openpic : item.closepic" alt="" style="width: 1rem;margin: -0.1rem .1rem 0 0;position: relative;left:-.5rem">
								<span  :style="{color:item.searchflag==1?'orange':''}">
									{{item.title}}
								</span>
								<a-icon type="right"  class='icon-right' :class='item.isshow?"icon-right0":"icon-right1"' />
							</div>
							<transition name="dropdown">
								<div v-if="!item.isshow"  >
									<div v-for="(val,index) in item.secondLevel" :key="index" >
										<div class="wil-list" style="position: relative;" @click="hand12(val,index,ind)">
											<span :style='{color:val.searchflag==1?"orange":staticadmin == val.menuid?"#0c8b97":""}'>{{val.title}}</span>
											<a-icon type="caret-right" class='icon-right' v-if="val.thirdLevel.length>0" :class='val.isshow?"icon-right0":"icon-right1"' />
										</div>
										<div  v-if='!val.isshow'>
											<div class="warp_top" style="background: #fff;" v-for="(cont,index1) in val.thirdLevel" :key="index1">
												<div class="wil-list"  @click="hand13(cont)" style="margin-left:1rem;">
													{{cont.title}}
												</div>
											</div>
										</div>
									</div>
								</div>
							</transition>
						
						</div>
					</div>
				</a-drawer>
				<router-view />
			</a-layout-content>
		</a-layout>
		<handhome v-if='handab' @child='handback'></handhome>
		<handout v-if='handoutimg' @child='tcEvent'></handout>
	</div>
</template>
<script>
	import Vue from 'vue'
	import App from '@/assets/app.js';
	import https from '@/plugins/http.js';
	import SubMenu from '@/components/subMenu/subMenu.vue';

	import sideListImg01 from '../../image/icon_shouye.png';
	import sideListImg11 from '../../image/icon_jiaoyi.png';
	import sideListImg21 from '../../image/icon_houtai.png';
	import sideListImg31 from '../../image/icon_shangcheng.png';

	import sideListImg02 from '../../image/icon_shouye1.png';
	import sideListImg12 from '../../image/icon_jiaoyi1.png';
	import sideListImg22 from '../../image/icon_houtai1.png';
	import sideListImg32 from '../../image/icon_shangcheng1.png';
	import handhome from './component/handhome.vue'
	
	Vue.component('handout',{
		data:function(){
			return{
				ishandout:true,
				ishand:false,
				itedit:false
			}
		},
		methods:{
			handleOk(){
				
			},
			handleCancel(ev){
				this.$emit("child",2)
			},
			
		},
		template:`<div>
		<a-modal v-show='!ishand' id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"25vh"}'
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
				<div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
					提 示
				</div>
			</div>
			<div solt='title' style="position: relative;"></div>
				<div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;
    align-items: center;'>
					<a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	您是否確認登出？
				</div>
				<div style="text-align: right">
					<button class='btn-main btn-main1' @click='$emit("child",2)'>取 消</button>
					<button class='btn-main' @click='$emit("child")'>確 認</button>
				</div>
		</a-modal>
	</div>`
	})

	export default {
		components: {
			'sub-menu': SubMenu,handhome,
		},
		data() {
			return {
				handoutimg:false,
				searchstr:'',
				threeLen:0,
				threeLen1:0,
				island:'',
				handab:false,
				isbright:'',
				numitem:'',
				isshowk: false,
				staticadmin: '',
				headright: [
					{
						// imgurl:require('@/image/heardright/link.png'),
						imgurl:require('@/image/heardright/qmis.png'),
						imgurl1:require('@/image/heardright/qmis.png'),
						name:'官方網站',
						widths:'calc(4.8rem)'
					},
					{
						imgurl:require('@/image/heardright/icon6.png'),
						imgurl1:require('@/image/heardright/icon6-1.png'),
						name:'收件箱',
						widths:'calc(4rem)',
						obj:{
							isshow: "true",
							menu_level: 2,
							menuid: 17,
							sort: 4,
							title: "客戶查詢",
							url: "/main/customerservice",
						}
					},
					// {
					// 	imgurl:require('@/image/heardright/icon3.png'),
					// 	name:'聯絡我們',
					// 	widths:'calc(4.8rem)'
					// },
					{
						imgurl:require('@/image/heardright/icon4.png'),
						imgurl1:require('@/image/heardright/icon4-2.png'),
						name:'控制中心',
						widths:'calc(4.8rem)'
					},
					// {
					// 	imgurl:require('@/image/heardright/icon5.png'),
					// 	imgurl1:require('@/image/heardright/icon5-2.png'),
					// 	name:'我的設定',
					// 	width:'calc(4.8rem)'
					// },
					{
						imgurl:require('@/image/heardright/outlook.png'),
						imgurl1:require('@/image/heardright/outlook.png'),
						name:'Technical Support',
						widths:'calc(8rem)'
					},
					{
						imgurl:require('@/image/heardright/times.png'),
						imgurl1:require('@/image/heardright/times.png'),
						name:'如閒置超過45分鐘，基於安全理由您的帳戶將會自動登出。',
						widths:'calc(10rem + 22px)'
					}
				],
				headpic: this.$store.state.headpic,
				userName: this.$store.state.realname,
				// 初始化選擇
				deKeyIndex: '',
				deOpenKeys: '',
				form:{
					realname:'',
					lastlogintime:'03/04/2021 12:12  GMT+08:00'
				},
				times:'',
				colorKey: '',
				// 控制侧边栏 缩放
				sideBol: false,
				// 頂部mess
				timeMess: '',
				// 計數器
				timer: '',
				// 侧边栏数据
				menuList: JSON.parse(localStorage.getItem('menuList')),
				sideListImgArr: ['', sideListImg01, sideListImg11, sideListImg21, sideListImg31],
				sideListOnImgArr: ['', sideListImg02, sideListImg12, sideListImg22, sideListImg32],
				istime:'',
				oneHeight:'',
				twoHeight:'',
				threeHeight:'',
			};
		},
		created() {
			let _this = this;
			// 初始化 選擇
			// _this.deKeyIndex = _this.$route.meta.keyIndex;
			// _this.deOpenKeys = _this.$route.meta.openKeys;
			// _this.colorKey = _this.$route.meta.openKeys;
			_this.timeLoad();
			_this.timeMake();
			//一级菜单
			setTimeout(() => {
				_this.deOpenKeys = _this.$store.state.openKeys || ''
				_this.colorKey = _this.$store.state.openKeys || ''
				//显示二级菜单
				// 	_this.deKeyIndex =  _this.$store.state.keyIndex||JSON.parse(localStorage.getItem('menuList'))[0][0].menuid
				_this.deKeyIndex = _this.$store.state.keyIndex || ''
			}, 100)
			
			
			// let _this = this;
			window.history.pushState(null,null,document.URL);
			window.addEventListener('popstate',()=>{
				let arr = JSON.parse(localStorage['menuList'])
				arr.map(ev=>{
					ev.secondLevel.map(val=>{
						if(val.url==this.$route.path){
							_this.staticadmin = val.menuid
							_this.$store.commit('handtitle', {
								title: val.title
							})
							ev.isshow = false
						}
					})
					
					if(ev.url==this.$route.path){
						_this.staticadmin = ''
						_this.$store.commit('handtitle', {
							title: ev.title||''
						})
					}
				})
				localStorage['menuList'] = JSON.stringify(arr)
				setTimeout(()=>{
					_this.menuList = arr
				},1500)
			},false)
		},
		mounted() {
			let time = this.$api.times
			if(this.$store.state.rolesdata.indexOf('talkonline') >= 0){
				this.istime = setInterval(()=>{
					this.getdata()
				},time)
			}
			// console.log(this.menuList)
			// 股票点击暂时处理方法 and
			// let add = {
			// 	outurl: null,
			// 	isshow: true,
			// 	closepic: null,
			// 	searchstr: "",
			// 	openpic: null,
			// 	menuid: 66,
			// 	menu_level: 3,
			// 	sort: 4,
			// 	title: "股票點擊",
			// 	url: "/main/stockClick"
			// }
			// this.menuList[1].secondLevel[1].thirdLevel.push(add)
			// console.log(this.menuList[1].secondLevel[1].thirdLevel);
			// 股票点击暂时处理方法 end
		},
		destroyed() {
			clearInterval(this.istime)
		},
		watch: {
		
			// deOpenKeys: {
			// 	handler(arr) {
			// 		// this.suopenKeys = [arr]
			// 	},
			// 	deep: true
			// },
		},
		methods: {
			getdata(){
				this.$ajax({
					method:'post',
					url:this.$api.getNoReadMsgNumber,
					data:{}
				}).then(res=>{
					if(res.data.qmiscode === 1000){
						this.island = res.data.num
					}else{
						// this.
					}
				})
			},
			handback(ev){
				this.numitem = ''
				this.isbright = ''
				this.handab = false
			},
			handicon(ind){
				return
				this.numitem = ind
				if(ind == 0){
					window.open('http://www.qmisgroup.com/TC/home')
				}else if(ind == 3){
					setTimeout(()=>{
						this.isbright = ind
					},200)
				}
			},
			
			//第二操作
			shEvent() {
				this.$ajax({
					url:this.$api.getUserMsg,
					method:'post',
					data:{
						token:this.$store.state.token
					}
				}).then(res=>{
					if (res.data.qmiscode === 1000) {
						this.form.realname = res.data.realname
						this.form.lastlogintime = res.data.lastlogintime
					}
				})
				// if (this.shShowBol) {
				this.isshowk = !this.isshowk
				// } else {

				// }
			},
			handfar(item,ind){
				// console.log(item);
				// var oneHeight = ''
				// // 2.3 *
				// oneHeight =  2.3 *item.secondLevel.length
				// if (item.isshow) {
				// 	this.oneHeight = oneHeight
				// }else{
				// 	this.oneHeight = 0
				// }
				console.log(this.oneHeight, item.isshow);
				if (item.thirdLevel1>0) {
					
				}else{
					this.$set(item,'thirdLevel1',0)
				}
				if(item.outurl) {
					window.open(item.outurl)
					return
				}
				// if (item.isshow) {
				// 	console.log(item.secondLevel);
				// 	alert(123)
				// }
				if(item.url){
					this.$store.commit('handtitle', {
						title: item.title
					})
				}
				item.isshow = !item.isshow
				item.searchflag = 0
				if(this.searchstr){
					this.searchstr = ''
					this.onSearch()
				}
				if(item.url){
					this.$router.push({
						path: item.url
					});
					this.sideBol = false
				}
			},
			handurl(a){
				if(a == 0){
					window.open('https://www.qmisgroup.com/')
				}
			},
			onSearch(ev){
				// if(this.searchstr){
					this.$ajax({
					method:'post',
					url:this.$api.AdminGetMenuList,
					headers: {
						token: this.$store.state.token
					},
					data:{
					searchstr:this.searchstr,
					token: this.$store.state.token
					}
				}).then(res=>{
					if(res.data.qmiscode ===1000){
						this.menuList = res.data.firstLevel
					}else{
						this.$message.warning(res.data.qmismsg)
					}
				})
				// }
			},
			//   this.$store.state.rolesdata.indexOf('acontractinsert') >= 0
			handis(val){
				if(this.$store.state.rolesdata.indexOf('talkonline') >= 0){
					this.hand12(val)
				}
			},
			hand13(val){
				if(val.url){
					this.$router.push({
						path: val.url
					});
					this.$store.commit('handtitle', {
						title: val.title
					})
					this.sideBol = false
				}
			},
			hand12(vals,index,ind) {

				// console.log(this.menuList[ind]);
				// var twolenght = 0
				// for (let j = 0; j < this.menuList[ind].secondLevel.length; j++) {
				// 	const jindex = this.menuList[ind].secondLevel[j];
				// 	for (let i = 0; i < jindex.thirdLevel.length; i++) {
				// 		const iindex = vals.thirdLevel[i];
				// 		if (iindex.isshow) {
				// 			twolenght += 1
				// 		}
						
				// 	}
				// }
				// console.log(twolenght,"二级");
				// // 2 *
				// var twoHeight = this.oneHeight + ( vals.thirdLevel.length)
				// if (vals.isshow) {
				// 	this.twoHeight = twoHeight
				// }else{
				// 	this.twoHeight = this.oneHeight

				// }

				// console.log(this.twoHeight , vals.isshow);
				// console.log(vals.thirdLevel.length);
				if (vals.isshow) {
					console.log(vals);
					if (vals.thirdLevel) {
						this.threeLen += vals.thirdLevel.length;
						this.$set(this.menuList[ind],'thirdLevel1',this.threeLen)
					}
				}
				this.staticadmin = vals.menuid
				this.$store.commit('handtitle', {
					title: ''
				})
				if(this.searchstr){
					this.searchstr = ''
					this.onSearch()
				}
				vals.searchflag = 0
				if(vals.url){
					this.$router.push({
						path: vals.url
					});
					this.$store.commit('handtitle', {
						title: vals.title
					})
					// for (let i = 0; i < this.menuList[ind].secondLevel.length; i++) {
					// 	const element = this.menuList[ind].secondLevel[i];
					// 	console.log(element);
					// 	if (element.thirdLevel>0) {
					// 		this.$set(this.menuList[ind],'thirdLevel1',element.thirdLevel.length+1)
					// 	}

					// }
					
				}
				vals.isshow = !vals.isshow
				console.log(this.menuList[ind],123123);
				
				if (vals.thirdLevel.length <= 0 && vals.thirdLevel) {
					this.$set(this.menuList[ind],'thirdLevel1',0)
				}else if (vals.isshow) {
					console.log(vals.thirdLevel.length);
					this.threeLen = (this.threeLen-vals.thirdLevel.length);
					this.$set(this.menuList[ind],'thirdLevel1',this.threeLen)
					// console.log(vals.thirdLevel.length);
					// if (vals.thirdLevel.length == 1) {
					// 	this.threeLen = 1;
					// }else{
					// 	this.threeLen = vals.thirdLevel.length;
					// }
						
				}

				this.menuList.map(val => {
					if (vals['key'] == val.menuid) {
						if (location.hash.split('#')[1] !== val.url) {
							if (val.url) {
								this.deOpenKeys = JSON.parse(localStorage.getItem('menuList'))[0].menuid
								this.colorKey = JSON.parse(localStorage.getItem('menuList'))[0].menuid
								this.deKeyIndex = ''
								this.$router.push({
									path: val.url
								})
								// this.sideBol = false
								// location.href = '#'+ val.url
							}
						}
					}
				})
				if(vals.url){
					this.sideBol = false
				}
				// this.sideBol = false
			},
			// hand12(vals,index,ind) {
			// 	console.log(vals,index);
				
			// 	// console.log(vals.thirdLevel.length);
			// 	if (vals.isshow) {
			// 		this.threeLen += vals.thirdLevel.length;
			// 		this.$set(this.menuList[ind],'thirdLevel1',this.threeLen)
			// 		console.log(this.menuList[ind]);
			// 	}
			// 	this.staticadmin = vals.menuid
			// 	this.$store.commit('handtitle', {
			// 		title: ''
			// 	})
			// 	if(this.searchstr){
			// 		this.searchstr = ''
			// 		this.onSearch()
			// 	}
			// 	vals.searchflag = 0
			// 	if(vals.url){
			// 		this.$router.push({
			// 			path: vals.url
			// 		});
			// 		this.$store.commit('handtitle', {
			// 			title: vals.title
			// 		})
			// 	}
			// 	vals.isshow = !vals.isshow
				 
			// 	console.log(vals.isshow);
			// 	if (vals.thirdLevel.length <= 0) {
			// 		this.$set(this.menuList[ind],'thirdLevel1',0)
			// 	}else if (vals.isshow) {
			// 		console.log(this.threeLen,vals.thirdLevel.length);
			// 		this.threeLen = (this.threeLen-vals.thirdLevel.length);
			// 		this.$set(this.menuList[ind],'thirdLevel1',this.threeLen)
			// 		// console.log(vals.thirdLevel.length);
			// 		// if (vals.thirdLevel.length == 1) {
			// 		// 	this.threeLen = 1;
			// 		// }else{
			// 		// 	this.threeLen = vals.thirdLevel.length;
			// 		// }
						
			// 	}

			// 	this.menuList.map(val => {
			// 		if (vals['key'] == val.menuid) {
			// 			if (location.hash.split('#')[1] !== val.url) {
			// 				if (val.url) {
			// 					this.deOpenKeys = JSON.parse(localStorage.getItem('menuList'))[0].menuid
			// 					this.colorKey = JSON.parse(localStorage.getItem('menuList'))[0].menuid
			// 					this.deKeyIndex = ''
			// 					this.$router.push({
			// 						path: val.url
			// 					})
			// 					// this.sideBol = false
			// 					// location.href = '#'+ val.url
			// 				}
			// 			}
			// 		}
			// 	})
			// 	if(vals.url){
			// 		this.sideBol = false
			// 	}
			// 	// this.sideBol = false
			// },
			timeLoad() {
				let _this = this;
				let date = new Date();
				let s = date.getSeconds();
				clearTimeout(_this.timer);
				this.times = setInterval(() => {
					_this.timeMake();
					_this.timer = setTimeout(() => {
						_this.timeMake();
					}, 60 * 1000)
				}, s * 1000);
			},
			timeMake() {
				let _this = this;
				let date = new Date();
				_this.timeMess = App.oMath._zeroCompletion(date.getDate()) + '/' + App.oMath._zeroCompletion(date
						.getMonth() + 1) + '/' + date.getFullYear() +
					' ' + App.oMath._zeroCompletion(date.getHours()) + ':' + App.oMath._zeroCompletion(date.getMinutes());
				// _this.timeMess = date.getFullYear() + '.' + App.oMath._zeroCompletion(date.getMonth() + 1) + '.' + App.oMath._zeroCompletion(date.getDate()) 
				//+ ' ' + App.oMath._zeroCompletion(date.getHours()) + ':' + App.oMath._zeroCompletion(date.getMinutes());
			},
			onClose() {
				this.sideBol = false;
			},
			changeSideBol(msg) {
				this.sideBol = msg;
			},
			tcEvent(ev) {
				if(ev==2){
					this.handoutimg = false
				}else{
					let _this = this;
					this.$ajax({
						url:this.$api.logout,
						method:'get',
						// data:{
						// 	token:this.$store.state.token
						// }
					}).then(res=>{
						if (res.data.qmiscode === 1000) {
							localStorage.clear()
							// location.href = '/'
							// localStorage.setItem('menuList', '');
							_this.$router.push({
								path: '/'
							});
							// location.href = location.protocol + location.hostname + '/qmisAdmin'
							// _this.$store.state.token = ''
						}
					})
				}
			},
			menuClick(item) {
				// item.keyPath.map(ev=>{
				// 	ev += ''
				// })
				this.$store.commit('startpage', item.keyPath)
				// if(item.menu_level == 1){//菜单 二级
				this.colorKey = item.keyPath.slice(-1)[0];
				// }
			}
		},
	};
</script>
<style >
	/* .dropdown-enter-active {
		transition: all 0.5s;
	}

	.dropdown-leave-active {
		transition: all 0.5s;
		filter: blur(2px);
	}

	.dropdown-enter,
	.dropdown-leave-to {
		opacity: 0;
	} */


	#handout .ant-modal-root .ant-modal-header, .ant-modal-root .ant-modal-body{
		background-color:#fff !important;
	}
	#handout .ant-modal-header,
	#handout .ant-modal-body {
		background-color: #fff !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}
	.right_div {
		border-bottom: 1px solid #f1f1f1;
		padding: .8rem;
		font-size: .7rem;
	}
	
	.mark-file {
		position: absolute;
		top: 0;
		left: 0;
	
		div {
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}
	#handout .ant-modal-close-x .anticon svg {
	    top: 1rem !important;
	    right: 0 !important;
	}
	#handout .btn-main{
		cursor: pointer;
		width: 5.5rem;
		height: 2rem;
		line-height: 2rem;    
		text-align: center;
		font-size: .8rem;
		color: #fff;
		border: 0;
		background-color: #0c8b97;
		border-radius: 3px;
	}
	#handout .btn-main1{
		margin: 0 1rem;
		background-color: #c8c8c8;
	}
	@media screen and (min-width: 1921px){
		#handout .ant-modal-close-x .anticon svg {
		    top: 1rem !important;
		    right: 0 !important;
		}
	}
</style>
<style lang="scss" scoped>
	
	
	.icon-right {
		position: absolute;
		right: .5rem;
		top: .6rem;
		width: 1rem;
		transform-origin: center center;
		/*设置图片旋转的中心点为左下角*/
		transition: all 0.5s;
		/*设置旋转的过渡效果：所有都过渡 过渡所需时间为0.8秒*/
	}

	.icon-right1 {
		transform: rotate(90deg);
		/*设置当鼠标经过盒子时第一个img的旋转角度为90°*/
	}

	.icon-right0 {
		transform: rotate(0deg);
		/*设置当鼠标经过盒子时第一个img的旋转角度恢复0°*/
	}

	.warp_top {
		transition: height .5s ease-out;
		-webkit-transition: height .5s ease-out;
		overflow: hidden;

	}

	.gre-title {
		position: relative;
		background-color: #0C8B96;
		color: #fff;
		padding-left: 1.5rem;
		border-bottom: .1px solid #d8d8d8;
		cursor:pointer;
	}

	.wil-list {
		background-color: #fff;
		color: #000;
		padding-left: 3rem;
		cursor: pointer;
	}

	.wil-list-tit {
		background-color: #fff;
		color: #000;
		padding-left: 1.5rem;
	}

	.gre-title,
	.wil-list,
	.wil-list-tit {
		height: 2.3rem;
		line-height: 2.3rem;
		font-size: .8rem;
	}
</style>